<button
  type="button"
  class="dropdown-item btn btn-link"
  [disabled]="isDisabled"
>
  <ng-content></ng-content>
</button>
